import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ImportsModule } from 'src/app/imports';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, ImportsModule, MenuComponent, HeaderComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  menuExpanded = true;

  onMenuStateChange(isExpanded: boolean): void {
    this.menuExpanded = isExpanded;
  }
}
